import { GridListTile } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import React, {
    useCallback,
    useContext,
    useMemo,
    useState,
    useRef,
    useEffect,
} from 'react';
import { useAsync } from 'react-use';
import styled from 'styled-components';

import {
    MOVIE_TYPE_COACH,
    VideoTypeTabContext,
} from '../../../contexts/VideoTypeTabContext';
import Api from '../../../utils/Api';
import {
    getMovieComparer,
    getMoviePredicate,
    getRefineWithYardRange,
} from '../../../utils/MovieSorting';
import { MovieDisplay } from '../../../utils/Video';
import MovieThumbnail from '../display/MovieThumbnail';
import VideoGridLayout from '../layout/VideoGridLayout';
import useSelectMovieDisplayHandler from '../../../hooks/useSelectMovieDisplayHandler';
import { Movie } from '../../../domains/resource/movie';

const StyledGridListTile = styled(GridListTile)`
    height: 150px !important;
    width: 19% !important;
    margin-right: 5px;
`;

const CoachMovies: React.FC = () => {
    const { movieType, SortClub, YardRanges, SortOrder } =
        useContext(VideoTypeTabContext);
    const [movies, setMovies] = useState<MovieDisplay[]>([]);
    const isMounted = useRef<boolean>(false); // useRefでマウント状態を追跡

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    // TODO: コーチビデオ追加時に検知できるようにしたい
    useAsync(async () => {
        const results = await Api.fetchAllStaffMovies();
        if (isMounted.current) {
            setMovies(
                results
                    .map((result) => new MovieDisplay(result))
                    .filter((p) => p.fetchable),
            );
        }
    }, []);

    const sortedMovies = useMemo(() => {
        return movies
            .filter(getMoviePredicate(SortClub))
            .filter(getRefineWithYardRange(YardRanges))
            .sort(getMovieComparer(SortOrder));
    }, [movies, SortClub, YardRanges, SortOrder]);

    const { onSelected } = useSelectMovieDisplayHandler();
    const handleClick = useCallback(
        (data: MovieDisplay) => {
            onSelected(Movie.fromEntity(data));
        },
        [onSelected],
    );

    return (
        <VideoGridLayout isVisible={movieType === MOVIE_TYPE_COACH}>
            {sortedMovies.map((video) => (
                <StyledGridListTile key={video.id}>
                    <MovieThumbnail
                        video={video}
                        onClick={handleClick}
                        isVisibleFavoriteButton={false}
                    />
                </StyledGridListTile>
            ))}
        </VideoGridLayout>
    );
};

export default observer(CoachMovies);
